import moment from 'moment';

import { EVChargingReservation, EVChargingReservationStatus, EVChargingReservationTypeCode, ChargingReservationTypeInfo, ReservationInvoice, InvoiceDetail, StartEndMeterDetails } from '../../entity/station/reservation';
import { EVChargerOutputPortTransformer } from './evcharger-ouput-port';
import { Slot } from "../../entity/slot";
import { Vehicle } from '@/entity/vehicle/vehicle';
import { StationTransformer } from './evcstation';
import { EVehicleTransformer } from './vehicle';
import { EVCBayOutletGunTransformer } from './evcstation-bay-outlet-gun';
import { Commercial } from '@/entity/commercial';
import { EVCStationBaySetup, EVCStationBayStatus, EVCBayOutlet, EVCBayOutletTariff } from '@/entity/station/evcbay';
import { EVChargerTransformer } from './evcharger';
import { Rate } from '@/entity/rate';
import { UOM } from '@/entity/uom';
import { EVChargerOutputTransformer } from './evcharger-output';
import { EVChargeTariff } from '@/entity/station/evcharge-tariff';

export class EVChargingReservationTransformer {
    transform(reservationInfo: any): EVChargingReservation {
        let commercial: { estimated?: Commercial, actual?: Commercial } = {}
        let installationDetailInfo = reservationInfo.installationDetail
        let gun = new EVCBayOutletGunTransformer().transform(installationDetailInfo.charger)
        gun.setup = new EVCStationBaySetup(
            installationDetailInfo.installationId,
            new StationTransformer().transform(installationDetailInfo.station),
            new EVChargerTransformer().transform(installationDetailInfo.charger),
            [],
            new EVCStationBayStatus("", "")
        )
        let dummyTariff = new EVCBayOutletTariff("", "", new Date(), new Date())
        let dummyTariffs = [dummyTariff]
        gun.outlet = new EVCBayOutlet("", "", new EVChargerOutputTransformer().transform(reservationInfo), [], new EVChargeTariff(reservationInfo.tariffCode, reservationInfo.tariffCode), dummyTariffs,"","")
        gun.port = new EVChargerOutputPortTransformer().transform(reservationInfo)
        let tarrifInfo = installationDetailInfo.charger
        gun.rate = new Rate(tarrifInfo.ratePerMinute, tarrifInfo.uom ? new UOM(tarrifInfo.uom, tarrifInfo.uom) : new UOM("minute", "/minute"))
        let reservation = new EVChargingReservation(
            reservationInfo.reservationId, {
            code: reservationInfo.reservationType.code,
                info: new ChargingReservationTypeInfo(reservationInfo.reservationType.code, reservationInfo.reservationType.description)
            }, 
            new StationTransformer().transform(reservationInfo.installationDetail.station),
            new Slot(moment(reservationInfo.startTime).toDate(), moment(reservationInfo.endTime).toDate()),
            new EVChargingReservationStatus(reservationInfo.status.code, reservationInfo.status.description),
            gun,
            reservationInfo.currentBatteryCapacity,
            reservationInfo.amountToCharge,
            reservationInfo.unitToCharge,
            new EVehicleTransformer().transform(reservationInfo.vehicle),
        )
        commercial.estimated = new Commercial(new Slot(moment(reservationInfo.startTime).toDate(), moment(reservationInfo.endTime).toDate()), reservationInfo.estimatedMinutes, reservationInfo.estimatedUOM, reservationInfo.estimatedUnit, reservationInfo.estimatedUnitUoM, reservationInfo.estimatedCost, reservationInfo.estimatedCGSTPercentage, reservationInfo.estimatedSGSTPercentage, reservationInfo.estimatedGSTPercentage, reservationInfo.estimatedCGST, reservationInfo.estimatedSGST, reservationInfo.estimatedGST, reservationInfo.estimatedNettCost)
        commercial.estimated.discountPercentage = reservationInfo.estimatedDiscountPercentage || 0
        commercial.estimated.discountAmount = reservationInfo.estimatedDiscountCost || 0
        commercial.estimated.taxableAmount = reservationInfo.estimatedDiscountedCost || 0
        commercial.estimated.distributionCharge = reservationInfo.estimatedDistributionCost || 0
        //Modified on 2020-12-16 for Bug#7
        if (reservationInfo.status.code == 'C') {
            commercial.actual = new Commercial(new Slot(moment(reservationInfo.actualStartTime).toDate(), moment(reservationInfo.actualEndTime).toDate()), reservationInfo.actualMinutes, reservationInfo.actualUOM, reservationInfo.actualUnit, reservationInfo.actualUnitUoM, reservationInfo.actualCost, reservationInfo.actualCGSTPercentage, reservationInfo.actualSGSTPercentage, reservationInfo.actualGSTPercentage, reservationInfo.actualCGST, reservationInfo.actualSGST, reservationInfo.actualGST, reservationInfo.actualNettCost)
            commercial.actual.discountPercentage = reservationInfo.actualDiscountPercentage || 0
            commercial.actual.discountAmount = reservationInfo.actualDiscountCost || 0
            commercial.actual.taxableAmount = reservationInfo.actualDiscountedCost || 0
            commercial.actual.distributionCharge = reservationInfo.actualDistributionCost || 0
        }
        reservation.commercial = commercial
        reservation.isTimeForCharging = reservationInfo.isTimeForCharging
        let profileInfo: any = reservationInfo.user
        if (profileInfo) {
            reservation.customer = {
                profile: {
                    userId: profileInfo.userId,
                    firstName: profileInfo.firstName,
                    lastName: profileInfo.lastName,
                    mobile: profileInfo.mobile
                }
            }
        }
        reservation.stationRating = reservationInfo.stationRating
        reservation.refNo = reservationInfo.reservationNo
        reservation.invoice = new ReservationInvoice(reservationInfo.invoiceNumber, reservationInfo.invoiceDate, reservationInfo.actualNettCost)
        //reservation.discountPercentage = reservationInfo.discountPercentage
        //reservation.discountedCost = reservationInfo.discountedCost
        //reservation.distributionCost = reservationInfo.distributionCost
        reservation.secretCode = reservationInfo.secretCode
        reservation.bayName = reservationInfo.bayName
        reservation.portName = reservationInfo.portName
        if (reservationInfo.invoiceDetails) {
            let invoiceDetails: InvoiceDetail[] = [];

            reservationInfo.invoiceDetails.forEach((invoiceDetail: { tariffCode: string; tariffTag: string; ToU: string; unitPrice: number; unitsConsumed: number; usageCost: number; reservationDetailsId: string }) => {
                invoiceDetails.push(new InvoiceDetail(invoiceDetail.tariffCode, invoiceDetail.tariffTag, invoiceDetail.ToU, invoiceDetail.unitPrice, invoiceDetail.unitsConsumed, invoiceDetail.usageCost, invoiceDetail.reservationDetailsId))
            });
            reservation.invoiceDetails = invoiceDetails
        }
        if(reservationInfo.CMSAdditionalMessage) {
            reservation.cmsAdditionalMessage = reservationInfo.CMSAdditionalMessage
        }
        if(reservationInfo.timeCompleted) {
            reservation.timeCompleted = reservationInfo.timeCompleted
        }
        if(reservationInfo.otherError) {
            reservation.otherError = reservationInfo.otherError
        }
        if(reservationInfo.startEndMeterDetails) {
            reservation.startEndMeterDetails = new StartEndMeterDetails(reservationInfo.startEndMeterDetails.endMeter,reservationInfo.startEndMeterDetails.startMeter)
        }
        
        return reservation
    }

    deTransform(reservation: EVChargingReservation): any {
        let reservationInfo: any = {
        }
        return reservationInfo
    }
}